import { Api } from '@vendor/js/api';
import Common from '@vendor/js/common';
import { Spinner } from '@vendor/js/spinner';
import { i18n } from '@vendor/libs/lang/lang';
const _ChangeRoleModalHandler = (function () {
    const initChangeRoleModalHandler = () => {
        const modal = $('#change_role_modal');
        const chooseRolesModal = $('#change_role_choose_roles_modal');
        let currentRoleGroupId = null;
        let currentEntityId = null;
        const table = modal.find('table').DataTable();
        $('body').on('click', '[data-app-choose_roles="button"]', async function () {
            Common.closeModal(modal);
            Common.openModal(chooseRolesModal);
            currentEntityId = $(this).attr('data-app-entity_id') ?? null;
            currentRoleGroupId = $(this).attr('data-app-id') ?? null;
            const spinner = new Spinner();
            try {
                const response = await Api.get(`/roles?role_group=${$(this).attr('data-app-id')}`);
                const modalBody = chooseRolesModal.find('.modal-body');
                modalBody.empty();
                for (const role of response.data.roles) {
                    modalBody.append(`
              <div class="form-check">
                <input class="form-check-input" type="checkbox" value="${role.name}" name="role" id="role_${role.id}" ${role.is_default ? 'checked' : ''}>
                <label class="form-check-label" for="role_${role.id}">
                  ${i18n.trans(role.display_name)}
                </label>
              </div>
            `);
                }
            }
            catch (err) {
                Common.handleErrorResponse(err);
            }
            finally {
                spinner.destroy();
            }
        });
        chooseRolesModal.on('hide.bs.modal', () => {
            Common.openModal(modal);
        });
        modal.on('show.bs.modal', async function () {
            table.clear();
            const spinner = new Spinner();
            try {
                const response = await Api.get('/role-groups');
                for (const roleGroup of response.data.roleGroups) {
                    const row = $(`
                          <tr>
                              <td>${roleGroup.entity_name}</td>
                              <td>${i18n.trans(roleGroup.entity_type_label)}</td>
                              <td>${i18n.trans(roleGroup.role_group_display_name)}</td>
                              <td class="text-end">
                                <button class="btn btn-sm btn-primary" data-app-id="${roleGroup.role_group_id}" data-app-entity_id="${roleGroup.entity_id}" data-app-choose_roles="button">
                                  ${i18n.trans('common.choose')}
                                </button>
                              </td>
                          </tr>
                      `);
                    table.rows.add(row);
                }
                table.draw();
            }
            catch (err) {
                Common.handleErrorResponse(err);
            }
            finally {
                spinner.destroy();
            }
        });
        chooseRolesModal
            .find(`[data-app-${chooseRolesModal.attr('id')}-action="cancel"]`)
            .on('click', function () {
            Common.closeModal(chooseRolesModal);
        });
        chooseRolesModal
            .find(`[data-app-${chooseRolesModal.attr('id')}-action="submit"]`)
            .on('click', function () {
            const roles = $(this)
                .closest('.modal')
                .find('[name="role"]:checked')
                .map(function () {
                return $(this).val();
            })
                .get();
            window.location.href = `/change-role-group?role_group=${currentRoleGroupId}&entity=${currentEntityId}&${roles
                .map((role, index) => `roles[]=${role}`)
                .join('&')}`;
        });
    };
    //
    return {
        // Public functions
        init: function () {
            initChangeRoleModalHandler();
        },
    };
})();
window.ChangeRoleModalHandler = _ChangeRoleModalHandler;
